import { envConfig } from '@/config/env';

export function getAppLocale(locale?: string) {
    if (envConfig.NEXT_PUBLIC_APP_MARKET === 'de') {
        return locale;
    }

    return undefined;
}
